import validate from 'lib/utils/validationRules';
import { isDateAfter } from 'lib/utils/date';
import { formatAmount } from 'lib/utils/amount';

const getCardList = (state) => state.cardList;

const getLinkedCard = (state) => state.cardList.find(card => card.linkedForPayout);

const isEmptyCardList = (state) => validate.isEmptyArray(state.cardList);

const isSingleAvailableCard = (state) => validate.isFixedLengthArray(state.cardList, 1);

const isNoLinkedCards = (state, getters) => validate.isUndefined(getters.getLinkedCard);

const isLinkedCardIsExpired = (state, getters, rootState, rootGetters) => {
  if (getters.isNoLinkedCards) {
    return false;
  }

  // Все карты банков РФ временно пролонгированы
  if (rootGetters.isRussianCurrency) {
    return false;
  }

  const { getLinkedCard: { expireDt } } = getters;

  return isDateAfter(new Date(), expireDt);
};

const isLinkedCardInBlacklisted = (state, getters) => {
  const { getLinkedCard: { blacklisted } } = getters;

  if (getters.isNoLinkedCards) {
    return false;
  }

  return blacklisted;
};

const linkedCardLimits = (state, getters) => {
  const { cardLimits } = state;
  const { getLinkedCard } = getters;

  if (validate.isUndefined(getLinkedCard)) {
    return null;
  }

  return cardLimits.find(item => item.cardId === getLinkedCard.id);
};

const bindingAmount = (state) => {
  const { bindingDetails } = state;

  // на тестовых провайдерах может не быть данных
  if (!validate.isObjectWithFields(bindingDetails, ['amount', 'currency'])) {
    return '5 ₽';
  }

  return formatAmount(bindingDetails.amount, bindingDetails.currency);
};

export default {
  getCardList,
  getLinkedCard,
  isEmptyCardList,
  isSingleAvailableCard,
  isNoLinkedCards,
  isLinkedCardIsExpired,
  isLinkedCardInBlacklisted,
  linkedCardLimits,
  bindingAmount,
};
